var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "nav location-nav display_flex_evenly"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: _vm.locationUrlPrefix
      },
      "custom": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var href = _ref.href,
          route = _ref.route,
          navigate = _ref.navigate;
        return [_c('a', {
          staticClass: "nav-link",
          class: [_vm.isRouteActive(route) && 'router-link-exact-active'],
          attrs: {
            "title": _vm.$t('floating_bar_options.overview'),
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('span', {
          staticClass: "icon icon-home"
        })])];
      }
    }])
  })], 1), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: _vm.locationUrlPrefix + '/charts'
      },
      "custom": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var href = _ref2.href,
          route = _ref2.route,
          navigate = _ref2.navigate;
        return [_c('a', {
          staticClass: "nav-link",
          class: [_vm.isRouteActive(route) && 'router-link-exact-active'],
          attrs: {
            "title": _vm.$t('floating_bar_options.charts'),
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('span', {
          staticClass: "icon icon-chart"
        })])];
      }
    }])
  })], 1), _vm.hasEvseFeature ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: _vm.locationUrlPrefix + '/ev-charging'
      },
      "custom": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref3) {
        var href = _ref3.href,
          navigate = _ref3.navigate;
        return [_c('a', {
          staticClass: "nav-link",
          class: [_vm.isEvChargingRouteActive && 'router-link-exact-active'],
          attrs: {
            "title": _vm.$t('floating_bar_options.ev_charging'),
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('span', {
          staticClass: "icon icon-car"
        })])];
      }
    }], null, false, 30808087)
  })], 1) : _vm._e(), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: _vm.locationUrlPrefix + '/strategies'
      },
      "custom": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref4) {
        var href = _ref4.href,
          route = _ref4.route,
          navigate = _ref4.navigate;
        return [_c('a', {
          staticClass: "nav-link",
          class: [_vm.isRouteActive(route) && 'router-link-exact-active'],
          attrs: {
            "title": _vm.$t('floating_bar_options.strategies'),
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('span', {
          staticClass: "icon icon-energy"
        })])];
      }
    }])
  })], 1), _c('li', {
    staticClass: "nav-item"
  }, [_c('div', {
    staticClass: "nav-link cursor-pointer alert-indicator",
    attrs: {
      "title": _vm.$t('floating_bar_options.notifications')
    },
    on: {
      "click": _vm.openNotificationsModal
    }
  }, [_c('span', {
    staticClass: "icon icon-bell"
  }), _vm.notificationCount > 0 ? _c('span', {
    staticClass: "alarms-count"
  }, [_vm._v(_vm._s(_vm.notificationCount))]) : _vm._e()])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }